import { Prisma } from "@prisma/client";
import { Paginated, Sortable } from "./utils.types";

export const eventFormQuestionArgs =
  Prisma.validator<Prisma.EventFormQuestionDefaultArgs>()({
    select: {
      id: true,
      theme: true,
      allowedEventTypes: true,
      question: true,
      answerType: true,
      isSystemQuestion: true,
      createdAt: true,
      updatedAt: true,
      options: {
        select: {
          id: true,
          questionId: true,
          label: true,
          order: true,
        },
        orderBy: {
          order: "asc",
        },
      },
    },
  });

export type EventFormQuestion = Prisma.EventFormQuestionGetPayload<
  typeof eventFormQuestionArgs
>;

export type EventFormQuestionFilters = Sortable<
  Paginated<{
    searchText?: string;
  }>
>;

export const eventFormQuestionAnswerTypeValues = [
  "short_text",
  "long_text",
  "multiple_choice",
  "checkbox",
  "list",
] as const;

export type EventFormQuestionAnswerType =
  (typeof eventFormQuestionAnswerTypeValues)[number];

export const answerTypesWithOptions: EventFormQuestionAnswerType[] =
  eventFormQuestionAnswerTypeValues.filter((type) =>
    ["multiple_choice", "checkbox", "list"].includes(type)
  );

export const eventFormQuestionAnswerTypeMap = {
  short_text: "Réponse courte",
  long_text: "Paragraphe",
  multiple_choice: "Choix multiples",
  checkbox: "Cases à cocher",
  list: "Liste déroulante",
} as const;

export const eventFormQuestionOnEventArgs =
  Prisma.validator<Prisma.EventFormQuestionOnEventDefaultArgs>()({
    select: {
      question: {
        select: eventFormQuestionArgs.select,
      },
      order: true,
    },
  });

export type EventFormQuestionOnEvent =
  Prisma.EventFormQuestionOnEventGetPayload<
    typeof eventFormQuestionOnEventArgs
  >;

export const cashRegisterFormQuestionOnEventArgs =
  Prisma.validator<Prisma.EventFormQuestionOnEventDefaultArgs>()({
    select: {
      id: true,
      order: true,
      isOnOnlineForm: true,
      isOnCashRegisterForm: true,
      cashRegisterOrder: true,
      question: {
        select: { ...eventFormQuestionArgs.select, eventId: true },
      },
    },
  });

export type CashRegisterFormQuestionOnEvent =
  Prisma.EventFormQuestionOnEventGetPayload<
    typeof cashRegisterFormQuestionOnEventArgs
  >;

export type OrganiserQuestionRemovalOutcome = "deleted" | "deactivated";

export interface DeleteOrganiserQuestionResponse {
  outcome: OrganiserQuestionRemovalOutcome;
}
